import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import appLogo from "../../assets/open/app-logo.png";
import appStoreBadge from "../../assets/open/appstore-badge.svg";
import googlePlayBadge from "../../assets/open/googleplay-badge.svg";
import "./Open.css";

const appStoreUrl = process.env.REACT_APP_OPEN_APP_STORE_URL;
const playStoreUrl = process.env.REACT_APP_OPEN_PLAY_STORE_URL;

export function OpenScreen() {
  const [opening, setOpening] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const timeoutRef = useRef();
  const storeUrl = /Android/i.test(navigator.userAgent || "")
    ? playStoreUrl || appStoreUrl
    : appStoreUrl || playStoreUrl;

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        window.clearTimeout(timeoutRef.current);
        setOpening(false);
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.clearTimeout(timeoutRef.current);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  const openApp = () => {
    window.clearTimeout(timeoutRef.current);
    setShowHelp(false);
    setOpening(true);
    timeoutRef.current = window.setTimeout(() => {
      setOpening(false);
      setShowHelp(true);
    }, 2200);
  };

  return (
    <main className="open-page">
      <div className="open-content">
        <div className="open-logo-frame">
          <img className="open-logo" src={appLogo} alt="Toppan App" />
        </div>

        <h1 className="open-title">Please install the app first</h1>

        {(appStoreUrl || playStoreUrl) && (
          <div className="open-stores">
            {appStoreUrl && (
              <a
                className="open-store-link"
                href={appStoreUrl}
                aria-label="Download on the App Store"
              >
                <img
                  className="open-store-badge"
                  src={appStoreBadge}
                  alt="Download on the App Store"
                />
              </a>
            )}
            {playStoreUrl && (
              <a
                className="open-store-link"
                href={playStoreUrl}
                aria-label="Get it on Google Play"
              >
                <img
                  className="open-store-badge"
                  src={googlePlayBadge}
                  alt="Get it on Google Play"
                />
              </a>
            )}
          </div>
        )}

        <div className="open-divider">
          <span>Once installed</span>
        </div>

        <p className="open-instructions">Return to this page and tap the button below</p>

        <a
          className="open-app-button"
          href={`https://digitalonboardingapp.toppansecurity.com/open${window.location.search}${window.location.hash}`}
          onClick={openApp}
          aria-busy={opening}
        >
          {opening && <span className="open-spinner" aria-hidden="true" />}
          {opening ? "Opening…" : "Open App"}
        </a>

        {showHelp && (
          <div className="open-help" role="status">
            {storeUrl ? (
              <>
                Nothing happening? Make sure the app is installed, or{" "}
                <a href={storeUrl}>visit the store</a>
                {" "}to download it again.
              </>
            ) : (
              "Nothing happening? Make sure the app is installed."
            )}
          </div>
        )}

        <p className="open-footnote">
          If the app is installed but still will not open, tap the original link again.
        </p>
      </div>
    </main>
  );
}

export function OpenNotFoundScreen() {
  return (
    <main className="open-page">
      <div className="open-content">
        <h1 className="open-title">404 Page not found</h1>
        <Link className="open-home-link" to="/open">
          Back to the app setup guide
        </Link>
      </div>
    </main>
  );
}
